module.exports = __webpack_public_path__ + "ua.svg?5196d8ea0993d5b917b04ddb206163ec";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ua.svg
// module id = 1669
// module chunks = 0